
import LazyImage from '@/components/lazy-image';
import ImageHelper from '@/utils/ImageHelper';
import { Comparator } from '@/ui-kit/enums';
import {
  StyleSizeType,
  StyleColorSchemeType,
  StyleFontWeightType,
  StylePositionType,
} from '@/ui-kit/styles/enums';
import SelectProvince from '@/components/inputs/province';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import UserSelectionStoreName from '@/store/user-selection/name';
import Gutter from '@/ui-kit/components/gutter';
import { PROVINCE_OPTIONS_NOT_ONTARIO } from '@/constants';

/**
 * @component Hero
 *
 * Hero component to be used in all pages
 *
 * @public
 */

export default {
  name: 'HeroComponent',
  components: {
    LazyImage,
    SelectProvince,
    Typography,
    Gutter,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      TypographyType,
      StyleColorSchemeType,
      StyleFontWeightType,
      StylePositionType,
      StyleSizeType,
      PROVINCE_OPTIONS_NOT_ONTARIO,
    };
  },
  computed: {
    imageRatio() {
      return ImageHelper.constructor.getImageRatio(this.data.image.dimensions);
    },
    heroImageSizes() {
      return [
        {
          comparator: Comparator.Less,
          breakpoint: StyleSizeType.XSmall,
          imageSize: 420,
        },
        {
          comparator: Comparator.Less,
          breakpoint: StyleSizeType.Small,
          imageSize: 600,
        },
        {
          comparator: Comparator.Less,
          breakpoint: StyleSizeType.Medium,
          imageSize: 800,
        },
        {
          comparator: Comparator.Greater,
          breakpoint: StyleSizeType.Medium,
          imageSize: 600,
        },
      ];
    },
    currentProvince() {
      return this.$store.state[UserSelectionStoreName].currentProvince;
    },
  },
};
